export default __webpack_public_path__ + "static/media/healthylab.271a7802.png";